import PathCard from './PathCard';

export default PathCard;
